<script>
import options from './StafetAddDeltager.options'
export default options
</script>

<template>
  <article class="kb-stafet-flow-add-participants kb-optimizely-forms">
    <div class="kb-stafet-step__input-wrapper">
      <FormInputTextField
        :modelValue="numberOfAdults.toString()"
        v-model="numberOfAdults"
        fieldName="numberOfAdults"
        :label="labels.registerDeltagereSelectAdultNumberLabel"
        :placeholder="labels.registerDeltagereSelectAdultNumberLabel"
        v-on:input="setNumberOfAdults($event.target.value)"
        type="number"
        :isValidationError="
          totalNumberOfParticipants === 0 && displayInputError
        "
        :errorMessageLabel="labels.registerDeltagereSelectAdultNumberErrorMessage"
      />

      <FormInputTextField
        :modelValue="numberOfChildren.toString()"
        v-model="numberOfChildren"
        :localValue="numberOfChildren"
        fieldName="numberOfChildren"
        :label="labels.registerDeltagereSelectChildNumberLabel"
        :placeholder="labels.registerDeltagereSelectChildNumberLabel"
        v-on:input="setNumberOfChildren($event.target.value)"
        type="number"
        :isValidationError="
          totalNumberOfParticipants === 0 && displayInputError
        "
        :errorMessageLabel="labels.registerDeltagereSelectChildNumberErrorMessage"
        />

      <template v-for="(adult, index) in adults">
        <div class="kb-stafet-step__input-wrapper">
          <h3>{{ labels.registerDeltagereAdultTitle }} {{ index + 1 }}</h3>

          <FormInputTextField
            :modelValue="adult.firstName"
            v-model="adult.firstName"
            fieldName="adultFirstName"
            :label="labels.registerDeltagereFirstNameLabel"
            :placeholder="labels.registerDeltagereFirstNameLabel"
            :isRequired="true"
            :isValidationError="
              !nonEmptyStringValidator(adult.firstName) && displayInputError
            "
            :errorMessageLabel="labels.registerDeltagereFirstNameErrorMessage"
          />
          
          <FormInputTextField
            :modelValue="adult.lastName"
            v-model="adult.lastName"
            fieldName="adultLastName"
            :label="labels.registerDeltagereLastNameLabel"
            :placeholder="labels.registerDeltagereLastNameLabel"
            :isValidationError="false"
            :isRequired="false"
          />

          <FormInputTextField
            v-if="!excludeMail"
            :modelValue="adult.email"
            v-model="adult.email"
            fieldName="adultEmail"
            :label="labels.registerDeltagereEmailLabel"
            :placeholder="labels.registerDeltagereEmailLabel"
            :isRequired="false"
            :isValidationError="(!!adult.email && !emailValidator(adult.email)) && displayInputError"
            :errorMessageLabel="labels.registerDeltagereEmailErrorMessage"
          />
        </div>
      </template>

      <template v-for="(child, index) in children">
        <div class="kb-stafet-step__input-wrapper">
          <h3>{{ labels.registerDeltagereChildTitle }} {{ index + 1 }}</h3>

          <FormInputTextField
            :modelValue="child.firstName"
            v-model="child.firstName"
            fieldName="childrenFirstName"
            :label="labels.registerDeltagereFirstNameLabel"
            :placeholder="labels.registerDeltagereFirstNameLabel"
            :isRequired="true"
            :isValidationError="!nonEmptyStringValidator(child.firstName) && displayInputError"
            :errorMessageLabel="labels.registerDeltagereFirstNameErrorMessage"
          />
        </div>
      </template>
    </div>
  </article>
</template>
